// Dependencies
import { FC } from "react";

// Components
import { BarLoader, HashLoader } from "react-spinners";

// Themes
import theme from "../Theme";

interface LoadingProps {}

export const HashLoading: FC<LoadingProps> = () => {
  return <HashLoader color={theme.palette.primary.main} />;
};

export const BarLoading: FC<LoadingProps> = () => {
  return <BarLoader color={theme.palette.primary.main} />;
};
